import "./App.css";
// Se carga despues de App.css para poder redefinir la maquetacion heredada.
import "./styles/editorial.css";
import Views from "./router/Views";

function App() {
  return (
        <Views />
  );
}

export default App;
